import {Component, EventEmitter, Input, Output} from '@angular/core';

import {ChartBoxElement} from '../dashboard.interfaces';

@Component({
  selector: 'gp-positions-card',
  templateUrl: './positions-card.component.html',
  styleUrls: ['./positions-card.component.scss']
})
export class PositionsCardComponent {

  @Input()
  public data: ChartBoxElement[];
  @Output() public selected: EventEmitter<{ link: string, value: number }> = new EventEmitter();

  constructor() {
  }

  public onSelect(element: ChartBoxElement): void {
    if (element.link) {
      this.selected.emit({link: element.link.href, value: element.value});
    }
  }
}
